import { Modal, Form, Input } from "antd";
import { useEffect } from "react";

export default function ProveedoresForm({ open, onCancel, onSubmit, initialValues }) {

  const [form] = Form.useForm();

  useEffect(() => {

    if (initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }

  }, [initialValues]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onSubmit(values);
        form.resetFields();
      });
  };

  return (
    <Modal
      open={open}
      title={
        initialValues
          ? "Editar proveedor"
          : "Nuevo proveedor"
      }
      okText="Guardar"
      cancelText="Cancelar"
      onCancel={onCancel}
      onOk={handleOk}
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          label="Nombre"
          name="nombre"
          rules={[
            { required: true, message: "Ingrese el nombre" }
          ]}
        >
          <Input placeholder="Nombre del proveedor" />
        </Form.Item>
        <Form.Item
          label="Identificación"
          name="identificacion"
        >
          <Input placeholder="NIT o identificación" />
        </Form.Item>
        <Form.Item
          label="Dirección"
          name="direccion"
        >
          <Input placeholder="Dirección del proveedor" />
        </Form.Item>
      </Form>
    </Modal>
  );
}